<template>
  <div id="website">
    <h1>Website</h1>
    <span v-for="page in pages" :key="page.id_pages">
      <CardsWeb :name="page.name" :id="page.id_pages"></CardsWeb
    ></span>
    <router-link to="/content">
      <a href="#" class="btn btn-primary">Adicionar Conteúdo</a></router-link
    >
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CardsWeb from "@/components/CardsWeb.vue";
export default {
  components: {
    CardsWeb,
  },
  data: function() {
    return {
      pages: [],
    };
  },
  created() {
    this.getPage();
  },
  methods: {
    async getPage() {
      try {
        await this.$store.dispatch("fetchPages");
        this.pages = this.getPages;
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getPages"]),
  },
};
</script>
<style scoped>
#website {
  padding: 50px 60px 0px 250px;
}
h1 {
  margin-bottom: 50px;
}
a {
  margin-top: 50px;
}
</style>
